import { CommonAPIService } from "src/servicehandlers/CommonHandler";

export class EventsAPIService {
  constructor() {
    this.CommonAPIService = new CommonAPIService();
  }

  get(router) {
    const url = `/api/events`;
    return this.CommonAPIService.getCall(url, null, router);
  }

  getEventById(eventId, router) {
    const url = `/api/events/${eventId}`;
    return this.CommonAPIService.getCall(url, null, router);
  }

  getEventsByDate(date, router) {
    const url = `/api/events/date/${date}`;
    return this.CommonAPIService.getCall(url, null, router);
  }

  getAllReservations(router) {
    const url = "/api/events/reservations";
    return this.CommonAPIService.getCall(url, null, router);
  }

  getEventsByUserIdAndDateRange(userId, params, router) {
    const url = `/api/events/userIdAndDateRange/${userId}`;
    return this.CommonAPIService.getCall(url, params, router);
  }

  getEventsByStudentIdAndDateRange(id, params, router) {
    const url = `/api/events/studentIdAndDateRange/${id}`;
    return this.CommonAPIService.getCall(url, params, router);
  }

  getEventsByInstructorIdAndDateRange(id, params, router) {
    const url = `/api/events/instructorIdAndDateRange/${id}`;
    return this.CommonAPIService.getCall(url, params, router);
  }

  getEventsByDpeIdAndDateRange(id, params, router) {
    const url = `/api/events/dpeIdAndDateRange/${id}`;
    return this.CommonAPIService.getCall(url, params, router);
  }

  getMaintenanceEvents(id, params, router) {
    const url = `/api/events/maintenance`;
    return this.CommonAPIService.getCall(url, params, router);
  }

  create(params, router) {
    const url = "/api/events";
    return this.CommonAPIService.postCall(url, params, router);
  }

  delete(eventId, params, router) {
    const url = `/api/events/${eventId}`;
    return this.CommonAPIService.deleteCall(url, params, router);
  }

  update(eventId, params, router) {
    const url = `/api/events/${eventId}`;
    return this.CommonAPIService.putCall(url, params, router);
  }

  getStatusOptions(router) {
    const url = `/api/events/eventStatusOptions`;
    return this.CommonAPIService.getCall(url, null, router);
  }
}
export default EventsAPIService;
